import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'extractChip',
  standalone: true
})
export class ExtractChipPipe implements PipeTransform {

  transform(user: string, ...args: unknown[]): string {
    return ExtractChipPipe.extractChip((user));
  }

  public static extractChip(userEmail: string): string {
    let parts = userEmail.split('.');
    let userChip = 'U';
    if(parts.length >= 2) {
      userChip = `${parts[0].substring(0, 1)}${parts[1].substring(0, 1)}`
    }
    return userChip.toUpperCase();
  }

}
